module.exports = __webpack_public_path__ + "static/media/people-24px.72bfac0d.svg";